
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-studio/figma",
      function () {
        return require("private-next-pages/ad-studio/figma.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-studio/figma"])
      });
    }
  